/**
 * Sends logs to multiple streams.
 */
export const compositeStream = (...streams) => (event) => streams.forEach((stream) => stream(event));
//# sourceMappingURL=compositeStream.js.map